import { config } from "./config";
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
  
import NotificationBagde from "./modules/push-notification/views/NotificationBadge";

import TabManager from "./lib/tab-manager";
import { deviceApi } from "./modules/identity/reducers/identitySlice"

import { ForegroundNotificationManager } from "./modules/push-notification/firebase";
import { notificationApi, selectRecentNotification } from './modules/push-notification/reducers/notificationSlice';
// import { selectConversationByIdOrFirtInList } from './modules/conversation/reducers/conversationSlice'; // TODO: generalizzare


const NotificationManager = () => {
//     const selectedConversationId = useSelector( (state) => state.conversationReducer.selectedConversationId) // TODO: generalizzare
//     const conversation = useSelector( (state) => selectConversationByIdOrFirtInList(state, selectedConversationId) ) // TODO: generalizzare
    const notifications = useSelector( (state) => selectRecentNotification(state, 5) )
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const onBadgeClick = (notification) => {
        navigate('/conversations', {state: { notification: notification.payload }}) // TODO: generalizzare
    }

    useEffect( () => {
        if(config.push_notification.enabled) {
            window.addEventListener('notification::onForegroundMessage', (event) => {
              console.log('notification::onForegroundMessage', event.detail); 
              dispatch( notificationApi.fetchLast() )
            }, false);
            
            window.addEventListener('notification::onBackgroundMessage', (event) => {
              console.log('notification::onBackgroundMessage', event.detail); 
              dispatch( notificationApi.fetchLast() )
            }, false);
            
            window.addEventListener('notification::onForegroundNotificationClick', (event) => {
              console.log('notification::onForegroundNotificationClick', event.detail); 
              onBadgeClick(event.detail.data);
            }, false);
            
            window.addEventListener('notification::onBackgroundNotificationClick', (event) => {
              console.log('notification::onBackgroundNotificationClick', event.detail); 
              onBadgeClick(event.detail.data);
            }, false);
    
            const notificationManager = new ForegroundNotificationManager();
            
            if(notificationManager) {
                notificationManager.initNotification(
                    (token) => {
                        console.log('TEST -  ForegroundNotificationManager - token', token)

                        dispatch(deviceApi.updateDevice({
                            enable_notification: true,
                            notification_token: token,
                            language: null
                        }))
                    },
                    () => {
                        return TabManager.getInstance().isElectedTab()
                    },
                    true  
                );
                console.log('ForegroundNotificationManager - UP', notificationManager);
            } else {
                console.log('ForegroundNotificationManager - DOWN', notificationManager);
            }
        }
    }, [dispatch] )

    const canNotify = (notification) => {
        // return (
        //     conversation === undefined // no conversation selected
        //     || notification.payload.conversation_sid !== conversation.conversation_sid // another conversation selected
        // ); // TODO: generalizzare
        return true
    }

    return (
        <div style={{ position: "absolute", top: "3%", right: "3%", zIndex: 9999, float: "right", width: "15%" }} >
            {notifications.map((notification) => canNotify(notification) 
                ? ( <NotificationBagde notification={notification} onBadgeClick={ onBadgeClick } key={notification.id} /> ) 
                : null
            )}
        </div>
    )
}
export default NotificationManager;